import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { afterItems, beforeItems } from '../../data/content';
export function BeforeAfterSection() {
  return <section aria-labelledby="compare-heading" className="bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-57" data-mp="1xotspxz95xp4">
      <div className="mx-auto max-w-5xl" data-id="element-58" data-mp="22nohdgjwigh5">
        <SectionHeading id="compare-heading" title="Imaginez vos prochaines formations avec une meilleure organisation…" data-id="element-59" data-mp="22qsrsvnym8g9" />

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-60" data-mp="1srliqko9czyy">
          <div className="rounded-[20px] bg-brand-ivory/70 p-7 sm:p-9" data-id="element-61" data-mp="1ezneoo9elu9n">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-charcoal/55" data-id="element-62" data-mp="1exaq3s954lnm">Avant</h3>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-63" data-mp="1517qat1rgz3u">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-brand-charcoal/60" data-id="element-64" data-mp="1a012mi5bak2f">
                  <XIcon className="mt-0.5 h-4 w-4 flex-none text-[#B5655E]" strokeWidth={2.25} aria-hidden="true" data-id="element-65" data-mp="27772pdz48rb9" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-[20px] border-2 border-brand-cta/40 bg-white p-7 shadow-[0_30px_60px_-40px_rgba(30,82,54,0.55)] sm:p-9" data-id="element-66" data-mp="2g8og2ol52ew9">
            <h3 className="font-body text-[12px] font-bold uppercase tracking-[0.16em] text-brand-cta" data-id="element-67" data-mp="2c4p50limo8aa">
              Avec Hair Instructor Ready™
            </h3>
            <ul className="mt-6 space-y-3.5" role="list" data-id="element-68" data-mp="1jj72lnfwzok0">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 text-[15px] font-medium leading-snug text-brand-charcoal" data-id="element-69" data-mp="1xakjsuqcoabv">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-70" data-mp="1shj2yh6l20pn" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-14 max-w-3xl text-center font-display text-[2rem] font-bold leading-tight text-brand-charcoal sm:text-[2.6rem]" data-id="element-71" data-mp="10ptosv4c1yrm">
          Enseignez avec plus de méthode, <Accent data-id="element-72" data-mp="34to8jv8i9zgj">sans tout reconstruire à chaque fois.</Accent>
        </p>
      </div>
    </section>;
}